import { FC } from 'react';
import RankTag from '@apps/components/RankTag';
import SoldChip from '@apps/components/SoldChip';
import usePostMsgContext from '@apps/containers/WebviewProvider/hooks';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useGetResponsive } from '@stack/helpers/lib/responsive';
import { redirect } from '@webbyx/next-js';
import Image from 'next/image';
import NextLink from 'next/link';

import { TopBrandItemProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const TopBrandItem: FC<TopBrandItemProps> = (props) => {
  const {
    rank,
    car_brand_name,
    car_brand_slug,
    car_brand_image,
    total_sold,
    total_search,
    type,
    basePath,
    webView = false,
  } = props;
  const { clickAction } = usePostMsgContext();
  const { isWeb } = useGetResponsive();
  const brandHref = `${basePath}/${car_brand_slug}`;

  // ============ VIEWS
  const renderChip = () => {
    if (type === 'Sold') {
      return <SoldChip label={total_sold} postfix={type} />;
    }
    return <SoldChip label={total_search} postfix={type} />;
  };

  return (
    <Stack
      component={NextLink}
      href={brandHref}
      onClick={(event) => {
        if (!webView) return;
        event.preventDefault();
        clickAction(brandHref, false, {
          title: car_brand_name,
          params: {
            brand: car_brand_slug,
          },
        });
      }}
      direction="row"
      justifyContent="space-between"
      alignItems={'center'}
      style={{ padding: '16px 0', alignItems: 'center', cursor: 'pointer' }}
    >
      <Stack
        direction="row"
        gap={4}
        alignItems={'center'}
        style={{ width: '40%' }}
      >
        <RankTag rank={rank ?? 0} />
        <Stack direction={'row'} alignItems={'center'} gap={4}>
          <Image
            alt={'brand'}
            src={car_brand_image ?? ''}
            height={44}
            width={44}
          />
          <Typography style={{ fontWeight: 700 }}>{car_brand_name}</Typography>
        </Stack>
      </Stack>
      {renderChip()}
      {isWeb && (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            redirect({}, `${basePath}/${car_brand_slug}`, 'push');
          }}
          style={{
            borderRadius: 0,
            background: '#1E242F',
            color: 'white',
            fontWeight: 700,
            fontSize: 13,
            textTransform: 'none',
            padding: '8px 30px',
          }}
        >
          View Car
        </Button>
      )}
    </Stack>
  );
};

/**
 * ===========================
 * EXPORT
 * ===========================
 */
export default TopBrandItem;
